import * as Sentry from '@sentry/react';

/**
 * Initialise Sentry for the web app.
 * No-op when VITE_SENTRY_DSN_WEB is empty (local development).
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN_WEB;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
    release: import.meta.env.VITE_APP_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
